import { GetAllBones } from "@project-rouge/rg-core";
import { BoneToVector } from "./index50.js";
import { getFflFromFloors } from "./index179.js";
function getRequiredCores(joint, dataset) {
  const bones = GetAllBones(joint);
  const aggConfig = dataset.aggConfig;
  const maxFloors = Math.max(...bones.map((b) => b.floors));
  const highestBones = bones.filter((b) => b.floors === maxFloors);
  const maxFfl = getFflFromFloors(dataset, maxFloors);
  let giaApprox = 0;
  const { moduleDepth, corridorWidth } = aggConfig;
  for (const bone of bones) {
    giaApprox += BoneToVector(bone).length() * (moduleDepth * bone.muscles.length + corridorWidth);
  }
  const stairRules = dataset.aggConfig.coreWithStairs.rules;
  const totalRequiredStairs = getCoreCountFromRules(stairRules, maxFfl, maxFloors, giaApprox);
  const liftCoreRules = dataset.aggConfig.coreWithLifts.rules;
  const totalRequiredLifts = getCoreCountFromRules(liftCoreRules, maxFfl, maxFloors, giaApprox);
  const fireCoreRules = dataset.aggConfig.coreWithFfLifts.rules;
  const totalRequiredFireLifts = getCoreCountFromRules(fireCoreRules, maxFfl, maxFloors, giaApprox);
  const requiredNonFireLifts = Math.max(0, totalRequiredLifts - totalRequiredFireLifts);
  const requiredStairs = Math.max(0, totalRequiredStairs - (totalRequiredFireLifts + requiredNonFireLifts));
  return { requiredFireLifts: totalRequiredFireLifts, requiredNonFireLifts, requiredStairs, highestBones };
}
function getCoreCountFromRules(stairRules, maxFfl, maxFloors, giaApprox) {
  let count = 0;
  if (stairRules) {
    for (const stairRule of stairRules) {
      if (stairRule.ffl && !(maxFfl >= stairRule.ffl[0] && maxFfl < stairRule.ffl[1])) {
        continue;
      }
      if (stairRule.floors && !(maxFloors >= stairRule.floors[0] && maxFloors < stairRule.floors[1])) {
        continue;
      }
      if (stairRule.gia && !(giaApprox >= stairRule.gia[0] && giaApprox < stairRule.gia[1])) {
        continue;
      }
      count = stairRule.count;
      break;
    }
  }
  return count;
}
export {
  getRequiredCores
};
//# sourceMappingURL=index53.js.map
